document.addEventListener('DOMContentLoaded', function () {
  function waitForElement(selector, callback, interval = 100, timeout = 10000) {
    let elapsed = 0;
    const timer = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(timer);
        callback(element);
      }
      elapsed += interval;
      if (elapsed >= timeout) clearInterval(timer);
    }, interval);
  }

  function scrollToWithOffset(element, offset = 50) {
    const top = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  const isAPDP = document.body.dataset.template === 'a-pdp';

  waitForElement('.yotpo-sr-bottom-line-summary', function (starWidget) {
    starWidget.style.cursor = 'pointer';

    starWidget.addEventListener('click', function () {
      if (isAPDP) {
        const widgetEl = document.querySelector('.yotpo-reviews-main-widget');
        if (widgetEl) {
          scrollToWithOffset(widgetEl);
        }
        return;
      }
      const hasWidget = !!document.querySelector('.yotpo-widget-instance');

      document.querySelectorAll('.product__accordion').forEach(function (accordion) {
        const yotpoReviews = accordion.querySelector('.yotpo-reviews-main-widget');
        const detailContainer = accordion.querySelector('details');

        if (yotpoReviews) {
          const summary = accordion.querySelector('summary');

          // Open accordion if not already open
          if (summary && detailContainer && !detailContainer.hasAttribute('open')) {
            summary.click();
          }

          // Scroll to widget if present, otherwise scroll to accordion
          if (hasWidget) {
            const widgetEl = document.querySelector('.yotpo-reviews-main-widget');
            scrollToWithOffset(widgetEl);
          } else {
            scrollToWithOffset(accordion);
          }
        }
      });
    });
  });
});
